import { Account } from 'api/Account/types';
import { useDeleteAccount } from 'components/AdminDashboard/components/AccountsPage/components/DeleteAccountPopover/hooks';

import React, { Dispatch, SetStateAction } from 'react';
import { Button, Grid, Popover, Typography } from '@mui/material';

interface Props {
  accountId: string
  onClose: () => void;
  anchorEl: HTMLElement;
  setAccounts: Dispatch<SetStateAction<Account[]>>;
}

const DeleteAccountPopover: React.FC<Props> = ({ accountId, anchorEl, onClose, setAccounts }) => {
  const onDeleted = () => {
    setAccounts((prevState) => {
      const accountIndex = prevState.findIndex(account => account.id === accountId);

      return [
        ...prevState.slice(0, accountIndex),
        ...prevState.slice(accountIndex + 1, prevState.length),
      ];
    });

    onClose();
  };

  const { deleteAccount, isSubmitting, submitError } = useDeleteAccount(onDeleted);

  return (
    <Popover
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      PaperProps={{
        elevation: 1,
        sx: { padding: 4 },
      }}
      onClose={onClose}
      data-testid="popover-delete-account"
      disableRestoreFocus
    >
      <Grid container display="flex" flexDirection="column">
        <Grid item sx={{ marginBottom: 1 }}>
          <Typography>
            Are you sure you want to delete the account?
          </Typography>
        </Grid>
        {
          submitError && (
            <Grid item xs={12}>
              <Typography color="error" variant="subtitle2">
                {submitError}
              </Typography>
            </Grid>
          )
        }
        <Grid item display="flex" justifyContent="flex-end">
          <Button
            disabled={isSubmitting}
            variant="contained"
            onClick={() => deleteAccount(accountId)}
            data-testid="button-delete-accout"
            sx={{ marginTop: 1 }}
          >
            Delete
          </Button>
        </Grid>
      </Grid>
    </Popover>
  );
};

export default DeleteAccountPopover;
